<template>
    <VueFinalModal
        class="flex items-center justify-center"
        overlay-class="bg-primary"
        content-class="flex flex-col max-w-[calc(100vw-2.75rem)] md:max-w-lg mx-4 p-6 md:p-8 bg-white rounded-lg space-y-2 relative"
        content-transition="fade-scale"
        :lock-scroll="false"
        :reserve-scroll-bar-gap="false">
        <NuxtImg :src="src" width="400" height="400" class="rounded" />
        <ModalCloseButton class="-right-4 -top-6" @click="emit('close')" />
    </VueFinalModal>
</template>

<script setup lang="ts">
    import { VueFinalModal } from 'vue-final-modal'
    import ModalCloseButton from '~/components/Modal/ModalCloseButton.vue'
    defineProps<{
        src?: string
    }>()
    const emit = defineEmits<{
        (e: 'close'): void
    }>()
</script>
